// src/pages/Credits/Credits.js

import React from "react";
import "./Credits.css";

function Credits() {
  return (
    <section className="credits-page">

      {/* HERO */}
      <div className="credits-hero">

        <p className="credits-tag">
          ROOTLY WEBSITE
        </p>

        <h1>
          Credits
        </h1>

        <p className="credits-subtitle">
          Recognition for the people and tools behind this website.
        </p>

      </div>

      {/* CONTENT */}
      <div className="credits-container">

        <div className="credits-card">

          <h2>Website Development</h2>

          <p>
            This website was designed and developed for Rootly Homoeopathy to
            provide a modern, responsive, and user-friendly digital experience.
          </p>

          <h2>Design & Branding</h2>

          <p>
            Layout, styling, branding visuals, icons, and user experience were
            created to reflect Rootly’s natural healing philosophy.
          </p>

          <h2>Technology Stack</h2>

          <p>
            Built using React.js, CSS3, Firebase, EmailJS, and modern web tools
            for speed, reliability, and appointment functionality.
          </p>

          <h2>Medical Content</h2>

          <p>
            Clinic information, doctor profile, services, and treatment areas
            were provided by Rootly Homoeopathy.
          </p>

          <h2>Special Thanks</h2>

          <p>
            Thank you to every patient, visitor, and supporter who trusts
            Rootly Homoeopathy.
          </p>

          <h2>Digital Partner</h2>

          <p>
            Website development and technical support by Rootly Digital Team.
          </p>

        </div>

      </div>

    </section>
  );
}

export default Credits;